export default __webpack_public_path__ + "static/media/0029.240a66d9.WAV";